import { render, staticRenderFns } from "./pig.vue?vue&type=template&id=5bf0e17f&scoped=true"
import script from "./pig.vue?vue&type=script&lang=js"
export * from "./pig.vue?vue&type=script&lang=js"
import style0 from "./pig.vue?vue&type=style&index=0&id=5bf0e17f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0e17f",
  null
  
)

export default component.exports